<!--
  *************************************************************************************************
-->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!--
  *************************************************************************************************
-->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <p-panel>
    <p-header>
      <!-- <i class="fa fa-file" aria-hidden="true"></i> Sessions -->
      <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{ sessions ? sessions.length : '0' }} {{
        'Sessions.sessions' | translate }}</span>
    </p-header>
    <p-table [value]="sessions" sortField="lastConnectionDate" sortOrder="1" [paginator]="false"
      class="footer-over-pagination">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="6">
            {{ 'Sessions.noActiveSession' | translate }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="identifier" styleClass="col-icon">{{ 'Sessions.clientType' | translate }} <p-sortIcon
              field="identifier"></p-sortIcon>
          </th>
          <th pSortableColumn="identifier" styleClass="col-3">Id <p-sortIcon field="identifier"></p-sortIcon>
          </th>
          <th pSortableColumn="user.identifier" styleClass="col-4">{{ 'General.user' | translate }} <p-sortIcon
              field="user.identifier"></p-sortIcon>
          </th>
          <th styleClass="col-2">{{ 'Sessions.lastConnectionDateColumn' | translate }}</th>
          <th styleClass="text-right action-column">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-session>
        <tr>
          <td field="identifier">
            <!-- Cliente web -->
            <span *ngIf="session.clientType">
              <i class="fa fa-2x fa-newspaper-o" aria-hidden="true"></i>
            </span>
            <!-- Cliente java -->
            <span *ngIf="!session.clientType">
              <i class="fa fa-2x fa-window-maximize" aria-hidden="true"></i>
            </span>
          </td>
          <td field="identifier">{{session.identifier}}</td>
          <td field="user.identifier">
            <user [user]="session.user"></user>
          </td>
          <td>{{ session.lastConnectionDate | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          <td>
            <button type="button" class="btn btn-xs btn-danger" style="width: 100%" aria-expanded="false"
              (click)="invalidateSession(session)">
              <i class="fas fa-ban" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>